export enum StorageEngine {
	Local = 'local',
	Session = 'session',
	IndexedDb = 'indexed_db'
}
